export const FORGOT_PASSWORD_SCREEN = 'forgotPassword'
export const LOGIN_SCREEN = 'login'